module.exports = __webpack_public_path__ + "img/thumb-video-2.905b6aaa.png";